import React from 'react';
import { Skeleton } from 'primereact/skeleton';

export const CustomSkeletonTile: React.FC = () => {
  return (
    <div className="tile-box">
      <Skeleton className="skeleton--box">
        <span />
      </Skeleton>
    </div>
  );
};
